// Form validation utilities
import { ValidationErrors } from '../types/auth.types';

/**
 * Validates email format
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validates password strength
 * Requirements: minimum 6 characters
 */
export const validatePassword = (password: string): boolean => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#()[\]{}._-])[A-Za-z\d@$!%*?&^#()[\]{}._-]{8,}$/;

  return passwordRegex.test(password);
};

/**
 * Validates that passwords match
 */
export const validatePasswordMatch = (password: string, confirmPassword: string): boolean => {
  return password === confirmPassword;
};

/**
 * Validates name field
 */
export const validateName = (name: string): boolean => {
  return name.trim().length >= 2;
};

/**
 * Validates sign-in form
 */
export const validateSignInForm = (email: string, password: string): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!email.trim()) {
    errors.email = 'Email is required';
  } else if (!validateEmail(email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (!password) {
    errors.password = 'Password is required';
  } else if (!validatePassword(password)) {
    errors.password =
      'Password must be at least 8 characters and include uppercase, lowercase, number, and special character';
  }

  return errors;
};

/**
 * Validates sign-up form
 */
export const validateSignUpForm = (
  name: string,
  email: string,
  password: string,
  confirmPassword: string,
  userRole: number,
  shift: string
): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!name.trim()) {
    errors.name = 'Name is required';
  } else if (!validateName(name)) {
    errors.name = 'Name must be at least 2 characters';
  }

  if (!email.trim()) {
    errors.email = 'Email is required';
  } else if (!validateEmail(email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (!password) {
    errors.password = 'Password is required';
  } else if (!validatePassword(password)) {
    errors.password =
      'Password must be at least 8 characters and include uppercase, lowercase, number, and special character';

  }

  if (!confirmPassword) {
    errors.confirmPassword = 'Please confirm your password';
  } else if (!validatePasswordMatch(password, confirmPassword)) {
    errors.confirmPassword = 'Passwords do not match';
  }

  if (!userRole) {
    errors.userRole = 'User role is required';
  }

  if (!shift) {
    errors.shift = 'Shift is required';
  }

  return errors;
};

/**
 * Validates forgot password form
 */
export const validateForgotPasswordForm = (email: string): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!email.trim()) {
    errors.email = 'Email is required';
  } else if (!validateEmail(email)) {
    errors.email = 'Please enter a valid email address';
  }

  return errors;
};
